import { useEffect, useRef } from 'react';
import { barBenefits } from '@/mocks/homeData';

export default function ForBarsSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.bars-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.12}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} id="for-bars" className="relative w-full py-24 md:py-32 bg-background-100">
      {/* Yellow accent line top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/20 to-transparent" />

      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — Text */}
          <div>
            <p className="bars-animate opacity-0 text-primary-500 text-xs font-bold tracking-[0.3em] uppercase mb-4">
              For Bars
            </p>
            <h2 className="bars-animate opacity-0 text-3xl sm:text-4xl md:text-5xl font-black text-foreground-50 tracking-tight leading-tight mb-6">
              Turn a drink into<br />
              <span className="text-primary-500">a reason to walk through the door.</span>
            </h2>
            <p className="bars-animate opacity-0 text-foreground-500 text-base leading-relaxed mb-8 max-w-md">
              MARKER helps bars create social interactions around drinks. Every sent drink brings a new customer through your door. No upfront cost. Real results.
            </p>
            <a
              href="https://api.yourmarkerapp.com/public/contactUs.html"
              target="_blank"
              rel="noopener noreferrer"
              className="bars-animate opacity-0 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-950 text-sm font-bold rounded-lg hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              Partner with MARKER
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* Right — Benefits grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {barBenefits.map((b) => (
              <div
                key={b.title}
                className="bars-animate opacity-0 p-5 rounded-2xl bg-background-950/60 border border-background-200/30"
              >
                <div className="w-10 h-10 rounded-xl bg-primary-500/20 flex items-center justify-center mb-4">
                  <i className="ri-store-3-line text-primary-500 text-lg" />
                </div>
                <h4 className="text-foreground-50 text-sm font-bold mb-2">{b.title}</h4>
                <p className="text-foreground-600 text-xs leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}